/**
 * Dynamic API Configuration
 * 
 * This configuration automatically determines the correct API base URL based on:
 * 1. Environment variable VITE_API_BASE_URL (highest priority)
 * 2. Localhost detection (for development)
 * 3. Current origin fallback (for production)
 */

const getApiBaseUrl = () => {
  // Priority 1: Check for environment variable
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  // Priority 2: Check if running on localhost (development)
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:5000/api';
  }

  // Priority 3: Production - use the correct Render backend URL
  if (typeof window !== 'undefined') {
    return 'https://api.dhirajth.me/api';
  }

  // Fallback for SSR or edge cases
  return 'https://api.dhirajth.me/api';
};

// Export the final API base URL
export const API_BASE_URL = getApiBaseUrl();

// Export a function to get the full URL for a specific endpoint
export const getApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Export configuration object for easy access
export const apiConfig = {
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Log the API configuration in development and production
console.log('🔧 API Configuration:', {
  baseURL: API_BASE_URL,
  environment: import.meta.env.MODE,
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'server',
  isDev: import.meta.env.DEV,
}); 